import React from 'react';

/**
 * CarouselContext
 * {
 *  direction: PropTypes.oneOf(['start', 'end']).isRequired,
 * }
 */
export const CarouselContext = React.createContext({});
